import { Injectable,NgZone } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { Platform, NavController } from '@ionic/angular';
import { AuthService } from './auth.service';
import { SubscriptionService } from './subscription.service';

@Injectable()
export class IsActive {

  
  private promise: Promise<string>;
  filename:string ="session";

  constructor(private subscriptionService:SubscriptionService,
    private authService:AuthService,
    private zone:NgZone,private router: Router,private platform: Platform,private route: Router,private navCtrl: NavController) {
  }

  async canActivate(route: ActivatedRouteSnapshot) {
    console.log(localStorage.getItem("status_subscriber"));
   
      if(parseInt(localStorage.getItem("status_subscriber"))  != 3){
        return true;
      }else{
        return false;
      }
    
    
   


      // const currentUser = this.authService.isLoggedIn;
      // if (!currentUser) {
      //     // authorised so return true
      //     this.navCtrl.navigateRoot(['/landing']);
      //     return false;
      // }
      // // not logged in so redirect to login page with the return url
      
      // return true;
  }
 
}

